import * as React from 'react';

import { IOwner, IEditablePet, ISelectOption } from '../../types';

import { url } from '../../util';

import LoadingPanel from './LoadingPanel';
import PetEditor from './PetEditor';

import createPetEditorModel from './createPetEditorModel';

interface INewPetPageProps {
  params: { ownerId: string };
}

interface INewPetPageState {
  pet?: IEditablePet;
  owner?: IOwner;
  pettypes?: ISelectOption[];
};

const NEW_PET: IEditablePet = {
  id: null,
  isNew: true,
  name: '',
  birthDate: null,
  typeId: null
};

export default class NewPetPage extends React.Component<INewPetPageProps, INewPetPageState> {

  componentDidMount() {
    createPetEditorModel(this.props.params.ownerId, Promise.resolve(NEW_PET))
      .then(model => this.setState(model));
  }

  render() {
    // Check if state exists and has required properties
    if (!this.state) {
      return <LoadingPanel />;
    }
    
    const { pet, owner, pettypes } = this.state;
    
    // Don't render until all required data is loaded
    if (!pet || !owner || !pettypes) {
      return <LoadingPanel />;
    }

    return <PetEditor pet={pet} owner={owner} pettypes={pettypes} />;
  }
}